/* eslint-disable no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SavedSelection } from '../../models/land';

interface InitialState {
  savedClaimLand: SavedSelection | null;
}

const initialState: InitialState = {
  savedClaimLand: null,
};

const savedSelectionSlice = createSlice({
  initialState,
  name: 'saved-selection',
  reducers: {
    clearSavedClaimedLand: (state: InitialState) => {
      state.savedClaimLand = initialState.savedClaimLand;
    },
    setSavedSelection: (
      state: InitialState,
      action: PayloadAction<SavedSelection>
    ) => {
      state.savedClaimLand = action.payload;
    },
  },
});

export const { setSavedSelection, clearSavedClaimedLand } =
  savedSelectionSlice.actions;

export default savedSelectionSlice.reducer;
